import _defineProperty from "/data/jenkins/workspace/mogdb-docs/mogdb-docs-prod/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../types.js').Handle} Handle
 */
import { checkQuote } from '../util/check-quote.js';
import { safe } from '../util/safe.js';
import { track } from '../util/track.js';
image.peek = imagePeek;
/**
 * @type {Handle}
 * @param {Image} node
 */

export function image(node, _, context, safeOptions) {
  var quote = checkQuote(context);
  var suffix = quote === '"' ? 'Quote' : 'Apostrophe';
  var exit = context.enter('image');
  var subexit = context.enter('label');
  var tracker = track(safeOptions);
  var value = tracker.move('![');
  value += tracker.move(safe(context, node.alt, _objectSpread({
    before: value,
    after: ']'
  }, tracker.current())));
  value += tracker.move('](');
  subexit();

  if ( // If there’s no url but there is a title…
  !node.url && node.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(node.url)) {
    subexit = context.enter('destinationLiteral');
    value += tracker.move('<');
    value += tracker.move(safe(context, node.url, _objectSpread({
      before: value,
      after: '>'
    }, tracker.current())));
    value += tracker.move('>');
  } else {
    // No whitespace, raw is prettier.
    subexit = context.enter('destinationRaw');
    value += tracker.move(safe(context, node.url, _objectSpread({
      before: value,
      after: node.title ? ' ' : ')'
    }, tracker.current())));
  }

  subexit();

  if (node.title) {
    subexit = context.enter('title' + suffix);
    value += tracker.move(' ' + quote);
    value += tracker.move(safe(context, node.title, _objectSpread({
      before: value,
      after: quote
    }, tracker.current())));
    value += tracker.move(quote);
    subexit();
  }

  value += tracker.move(')');
  exit();
  return value;
}
/**
 * @type {Handle}
 */

function imagePeek() {
  return '!';
}